module.exports = __webpack_public_path__ + "img/home-prize-3.b02043c3.png";